var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBonusTemplate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.11 20.04",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26431",
    "data-name": "Group 26431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26404",
    "data-name": "Group 26404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26383",
    "data-name": "Group 26383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_template_798187",
    "data-name": "noun template 798187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26380",
    "data-name": "Group 26380",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46796",
    "data-name": "Path 46796",
    d: "M878.73,457h11.39a.41.41,0,0,0,.35-.4V452a.88.88,0,0,0-.77-1h-11a.41.41,0,0,0-.35.4v5.2A.41.41,0,0,0,878.73,457Z",
    transform: "translate(-872.38 -450.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46798",
    "data-name": "Path 46798",
    d: "M876.45,451h-2.94a1,1,0,0,0-1.12.88s0,.08,0,.12v18a1,1,0,0,0,1,1h3.05a.45.45,0,0,0,.45-.4v-19.2A.45.45,0,0,0,876.45,451Z",
    transform: "translate(-872.38 -450.98)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Star_3411624",
    "data-name": "noun Star 3411624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_10",
    "data-name": 10
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46840",
    "data-name": "Path 46840",
    d: "M890.23,464.4l-2.31,2.33.54,3.29a.84.84,0,0,1-.32.84.75.75,0,0,1-.87.05l-2.85-1.55-2.86,1.55a.8.8,0,0,1-.38.1.77.77,0,0,1-.48-.16.86.86,0,0,1-.32-.83l.55-3.29-2.32-2.33a.88.88,0,0,1-.23-.88.82.82,0,0,1,.68-.57l3.19-.48,1.43-3a.8.8,0,0,1,1.47,0l1.43,3,3.19.48a.81.81,0,0,1,.68.57A.85.85,0,0,1,890.23,464.4Z",
    transform: "translate(-872.38 -450.98)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBonusTemplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_bonusTemplate.5f2135db7607fd199e570804a64b456c.svg";